import { KrossBookingProperty } from "../_modelsTS/Integration";
import { GenericCollectionFactory } from "../_generics";

export const KrossBookingStore = GenericCollectionFactory<KrossBookingProperty>("KROSS-BOOKING-INTEGRATION", "id_property");